import React, { useState } from "react";
import "./contactForm.css";
import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram } from 'react-icons/fa'; // Social media icons
import { FaMapMarkerAlt, FaPhone, FaEnvelope } from 'react-icons/fa'; // Icons for contact details
import emailjs from '@emailjs/browser';

export const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs.send(
      'service_ycqc99a', // Replace with your EmailJS service ID
      'template_u2gju3t', // Replace with your EmailJS template ID
      formData,
      'Jd_qYXErEVj6j3ruh' // Replace with your EmailJS public key
    )
    .then((response) => {
      console.log('SUCCESS!', response.status, response.text);
      setStatus('Message sent successfully!');
    })
    .catch((error) => {
      console.error('FAILED...', error);
      setStatus('Failed to send the message. Please try again.');
    });

    // Clear form fields
    setFormData({
      name: '',
      email: '',
      message: '',
    });
  };

  return (
    <div className="contact-container">
      <h1>Contact Us</h1>
      <p>We’d love to hear from you! Fill out the form below or connect with us on social media.</p>
      
      <form className="contact-form" onSubmit={handleSubmit}>
        <label>
          Name:
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Enter your full name"
            required
          />
        </label>
        
        <label>
          Email:
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Enter your email address"
            required
          />
        </label>
        
        <label>
          Message:
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="Type your message here"
            required
          ></textarea>
        </label>
        
        <button type="submit">Send Message</button>
      </form>

      {status && <p className="status-message">{status}</p>}

      {/* Contact Information Section */}
      <div className="contact-info">
        <div className="info-item">
          <FaMapMarkerAlt className="info-icon" />
          <p>
            <a 
              href="https://maps.app.goo.gl/gXiAnXnmTd9Uoo3T9" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              13b, Hor Al anz, Deira, Dubai, UAE
            </a>
          </p>
        </div>

        <div className="info-item">
          <FaPhone className="info-icon" />
          <p><a href="tel:+971505887449">+971505887449</a></p>
        </div>
        <div className="info-item">
          <FaEnvelope className="info-icon" />
          <p><a href="mailto:stannumhrconsultanciesllc@gmail.com">stannumhrconsultanciesllc@gmail.com</a></p>
        </div>
      </div>

      <div className="social-media-links">
        <a href="https://www.facebook.com/share/1MVSnDcj5a/?mibextid=LQQJ4d" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
          <FaFacebook />
        </a>
        <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
          <FaTwitter />
        </a>
        <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
          <FaLinkedin />
        </a>
        <a href="https://www.instagram.com/stannumhrconsultanciesllc/profilecard/?igsh=dXh5MG42dHZtZWM2" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
          <FaInstagram />
        </a>
      </div>
    </div>
  );
};
